'use client';

import { flatten } from 'lodash-es';
import { useAuth } from 'react-oidc-context';

import type { BuyingGuideRenderer } from '@zoomit/editor';
import { useMultipleReviewInfo } from '@zoomit/web-kit';
import { Typography } from '@zoomit/zoomit-ds';

import RelatedProductSingle from '../related-product/RelatedProductSingle';

type Props = {
  blockData: BuyingGuideRenderer;
};

const BuyingGuideBlock = (props: Props) => {
  const { blockData } = props;
  const { isLoading } = useAuth();

  const { data: reviewData } = useMultipleReviewInfo({
    topicIds: flatten(blockData.subheadings.map((s) => s.products.map((p) => p.id))),
    topicType: 'Product',
    enabled: !isLoading,
  });

  return (
    <>
      {blockData.subheadings.map((subHeadingData) => {
        return (
          <>
            <Typography className="fa" variant="h2" lineHeight={1.82}>
              {subHeadingData.title}
            </Typography>
            <RelatedProductSingle
              template="single_product_complete"
              blockData={subHeadingData}
              reviewData={reviewData}
            />
          </>
        );
      })}
    </>
  );
};

export default BuyingGuideBlock;
